export const LOT_ALREADY_SOLD_API_ERROR_MSG = 'Lot was already sold.';
export const RESERVE_BID_SELL_API_ERROR_MSG = 'Cannot sell to automated bidder.';
